angular.module('homebot.services')

.factory('RollbarService', ['Rollbar', 'APP_CONFIG', function(Rollbar, APP_CONFIG){
  function logMessage(message, data){
    console.log('Message sent to rollbar:', message, data);
  };

  return {
    error: function(message, data = {}){
      if(!APP_CONFIG.ROLLBAR_ENV) return logMessage(message, data);
      
      // Data can be a JS Error instance
      Rollbar.error(message, data);
    },
    
    info: function(message, data = {}){
      if(!APP_CONFIG.ROLLBAR_ENV) return logMessage(message, data);

      Rollbar.info(message, data);
    },
  }
}]);
